import React from 'react';

const UserCashTransactionFormModal = React.lazy(() => import('../components/FormModal'));
const userCashTransactionModalRegistry = {
    core_userCashTransactionId: UserCashTransactionFormModal
};
export default userCashTransactionModalRegistry;
